export class UfLabel {
  label: string;
  uf: string;
  constructor(value: string, label: string) {
    this.label = label;
    this.uf = value;
  }
}
export const EstadosSiglaLabel = [
  new UfLabel("AC", "Acre"),
  new UfLabel("AL", "Alagoas"),
  new UfLabel("AP", "Amapá"),
  new UfLabel("AM", "Amazonas"),
  new UfLabel("BA", "Bahia"),
  new UfLabel("CE", "Ceará"),
  new UfLabel("DF", "Distrito Federal"),
  new UfLabel("ES", "Espírito Santo"),
  new UfLabel("GO", "Goiás"),
  new UfLabel("MA", "Maranhão"),

  new UfLabel("MT", "Mato Grosso"),
  new UfLabel("MS", "Mato Grosso do Sul"),

  new UfLabel("MG", "Minas Gerais"),
  new UfLabel("PA", "Pará"),

  new UfLabel("PB", "Paraíba"),
  new UfLabel("PR", "Paraná"),

  new UfLabel("PE", "Pernambuco"),
  new UfLabel("PI", "Piauí"),

  new UfLabel("RJ", "Rio de Janeiro"),
  new UfLabel("RN", "Rio Grande do Norte"),

  new UfLabel("RS", "Rio Grande do Sul"),
  new UfLabel("RO", "Rondônia"),
  new UfLabel("SC", "Santa Catarina"),
  new UfLabel("SP", "São Paulo"),

  new UfLabel("SE", "Sergipe"),
  new UfLabel("TO", "Tocantins"),
];
